// src/Data/portfolioDataMultiLang.js

export const PORTFOLIO_PROJECTS_MULTI_LANG = {
  en: [
    {
      id: 1,
      title: 'Brand Identity Design',
      categories: ['Branding', 'Marketing'],
      client: 'Al-HURRA',
      year: '2024',
      description: 'Complete brand identity including logo, color palette, typography, and brand guidelines for a premium  agroalimentary products Tunisian brand .',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777381429/alhurra_vtj9nb.png',
      tags: ['Logo Design', 'Brand Guidelines', 'Visual Identity'],
      link: 'https://www.behance.net/gallery/222043395/AL-HURRA-PROJECT',
      featured: true,
    },
       {
      id: 2,
      title: 'Brand Identity Design',
    categories: ['Social Media', 'Design'], // Array of strings
      client: 'JAZIA Restaurant',
      year: '2025',
      description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777381266/jazia_restaurant_qwab8w.png',
      tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
      link: '#',
      featured: true,
    },
        {
      id: 3,
      title: 'Brand Identity Design',
    categories: ['Social Media', 'Design'], // Array of strings
      client: 'AlFerdaws Dates',
      year: '2025',
      description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777381509/al_ferdaws_dates_krx89y.png',
      tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
      link: '#',
      featured: true,
    },
        {
      id: 4,
      title: 'Brand Identity Design',
    categories: ['Social Media', 'Design'], // Array of strings
      client: 'clean Up',
      year: '2025',
      description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777380403/cleanup_logo_p8bw4c.png',
      tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
      link: '#',
      featured: true,
    },
        {
      id: 5,
      title: 'Brand Identity Design',
    categories: ['Social Media', 'Design'], // Array of strings
      client: 'Jarayti Tn',
      year: '2025',
      description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777380661/jarayti_tn_jx1pkp.png',
      tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
      link: '#',
      featured: true,
    },
        {
      id: 6,
      title: 'Brand Identity Design',
    categories: ['Social Media', 'Design'], // Array of strings
      client: 'Naqalni',
      year: '2025',
      description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777380844/naqalni_czpgrb.png',
      tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
      link: '#',
      featured: true,
    },
        {
      id: 7,
      title: 'Brand Identity Design',
    categories: ['Social Media', 'Design'], // Array of strings
      client: 'Sweet Home',
      year: '2025',
      description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777380843/sweet_home_dezcfm.png',
      tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
      link: '#',
      featured: true,
    },
    //         {
    //   id: 8,
    //   title: 'Brand Identity Design',
    // categories: ['Social Media', 'Design'], // Array of strings
    //   client: 'Frippe wasla',
    //   year: '2025',
    //   description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
    //   image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777381149/frippe_wasla_wodhqv.png',
    //   tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
    //   link: '#',
    //   featured: true,
    // },
    //         {
    //   id: 9,
    //   title: 'Brand Identity Design',
    // categories: ['Social Media', 'Design'], // Array of strings
    //   client: 'Magie Agencement',
    //   year: '2025',
    //   description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
    //   image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777380849/magie_agencement_je652k.png',
    //   tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
    //   link: '#',
    //   featured: true,
    // },
            {
      id: 10,
      title: 'Brand Identity Design',
    categories: ['Social Media', 'Design'], // Array of strings
      client: 'Carthage Store',
      year: '2025',
      description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777380589/carthage_store_ilcwq9.png',
      tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
      link: '#',
      featured: true,
    },
            {
      id: 11,
      title: 'Brand Identity Design',
    categories: ['Social Media', 'Design'], // Array of strings
      client: 'Salam Mosque',
      year: '2025',
      description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777380078/logo_salam_mosquee_nqb1vk.png',
      tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
      link: '#',
      featured: true,
    },
  
                {
      id: 12,
      title: 'Brand Identity Design',
    categories: ['Social Media', 'Design'], // Array of strings
      client: 'ElMajalla',
      year: '2025',
      description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777461860/elmajalla_y7uo6p.png',
      tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
      link: '#',
      featured: true,
    },
    //             {
    //   id: 13,
    //   title: 'Brand Identity Design',
    // categories: ['Social Media', 'Design'], // Array of strings
    //   client: 'Electro Dubai',
    //   year: '2025',
    //   description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
    //   image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777461860/electro_dubai_addee5.png',
    //   tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
    //   link: '#',
    //   featured: true,
    // },
    //             {
    //   id: 14,
    //   title: 'Brand Identity Design',
    // categories: ['Social Media', 'Design'], // Array of strings
    //   client: 'Yeinzo',
    //   year: '2025',
    //   description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
    //   image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777461860/yeinzo_laqr2t.png',
    //   tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
    //   link: '#',
    //   featured: true,
    // },
    //             {
    //   id: 15,
    //   title: 'Brand Identity Design',
    // categories: ['Social Media', 'Design'], // Array of strings
    //   client: 'Tera Store',
    //   year: '2025',
    //   description: 'Complete brand identity including social Media posters, videos, social media marketing, color palette, typography, and brand guidelines for a tunisian restuarant.',
    //   image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1777461860/tera_store_myuxjr.png',
    //   tags: ['Social Media', 'Brand Guidelines', 'Visual Identity'],
    //   link: '#',
    //   featured: true,
    // },


  ],
  
  ar: [
      {
      id: 1,
      title: 'تصميم الهوية البصرية',
        categories: ['Branding', 'Marketing'],
      client: 'الحرّة',
      year: '2024',
      description: 'هوية بصرية كاملة تشمل الشعار، لوحة الألوان، الطباعة، وإرشادات العلامة التجارية لعلامة تونسية فاخرة متخصصة في المنتجات الزراعية الغذائية.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1768406503/Artboard_1_qdykuz.jpg',
      tags: ['تصميم الشعار', 'إرشادات العلامة التجارية', 'الهوية البصرية'],
      link: 'https://www.behance.net/gallery/222043395/AL-HURRA-PROJECT',
      featured: true,
    },
    {
  id: 2,
  title: 'تصميم الهوية البصرية',
  categories: ['وسائل التواصل الاجتماعي', 'تصميم'],
  client: 'مطعم جزية',
  year: '٢٠٢٥',
  description: 'هوية بصرية كاملة تشمل ملصقات وسائل التواصل الاجتماعي، وفيديوهات، وتسويق وسائل التواصل الاجتماعي، ونظام الألوان، والطباعة، وإرشادات العلامة التجارية لمطعم تونسي.',
  image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1768407152/logo_jpg_hr81aw.jpg',
  tags: ['وسائل التواصل الاجتماعي', 'إرشادات العلامة التجارية', 'الهوية البصرية'],
  link: '#',
  featured: true,
}
  
  ],
  
  it: [
   {
      id: 1,
      title: 'Design dell\'Identità di Marca',
        categories: ['Branding', 'Marketing'],
      client: 'Al-HURRA',
      year: '2024',
      description: 'Identità di marca completa che include logo, palette di colori, tipografia e linee guida del brand per un marchio tunisino di prodotti agroalimentari di lusso.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1768406503/Artboard_1_qdykuz.jpg',
      tags: ['Design del Logo', 'Linee Guida del Brand', 'Identità Visiva'],
      link: 'https://www.behance.net/gallery/222043395/AL-HURRA-PROJECT',
      featured: true,
    },
    {
  id: 2,
  title: 'Progettazione Identità di Marca',
  categories: ['Social Media', 'Design'],
  client: 'Ristorante JAZIA',
  year: '2025',
  description: 'Identità di marca completa inclusi poster per social media, video, marketing sui social media, palette di colori, tipografia e linee guida del brand per un ristorante tunisino.',
  image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1768407152/logo_jpg_hr81aw.jpg',
  tags: ['Social Media', 'Linee Guida del Brand', 'Identità Visiva'],
  link: '#',
  featured: true,
}
  
  ],
  
  fr: [
     {
      id: 1,
      title: 'Design d\'Identité de Marque',
        categories: ['Branding', 'Marketing'],
      client: 'Al-HURRA',
      year: '2024',
      description: 'Identité de marque complète incluant logo, palette de couleurs, typographie et directives de marque pour une marque tunisienne premium de produits agroalimentaires.',
      image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1768406503/Artboard_1_qdykuz.jpg',
      tags: ['Design de Logo', 'Directives de Marque', 'Identité Visuelle'],
      link: 'https://www.behance.net/gallery/222043395/AL-HURRA-PROJECT',
      featured: true,
    },
    {
  id: 2,
  title: 'Conception d\'Identité de Marque',
  categories: ['Réseaux Sociaux', 'Design'],
  client: 'Restaurant JAZIA',
  year: '2025',
  description: 'Identité de marque complète incluant affiches pour réseaux sociaux, vidéos, marketing sur les réseaux sociaux, palette de couleurs, typographie et guide de style pour un restaurant tunisien.',
  image: 'https://res.cloudinary.com/dzg4ssjwz/image/upload/v1768407152/logo_jpg_hr81aw.jpg',
  tags: ['Réseaux Sociaux', 'Guide de Marque', 'Identité Visuelle'],
  link: '#',
  featured: true,
}
  ],

};

// Helper function to get projects for current language
export const getProjectsByLanguage = (language) => {
  return PORTFOLIO_PROJECTS_MULTI_LANG[language] || PORTFOLIO_PROJECTS_MULTI_LANG.en;
};

export default PORTFOLIO_PROJECTS_MULTI_LANG;